import { Box, Text, Input } from "@chakra-ui/react";

const InputComponent = ({ label, value, onChange, placeholder, disabled=false, theme="light", onBlur }) => {
    const themeStyle = theme === "dark" ? {
        box: {
            borderRadius: "0px",
            border: "1px solid #575656",
        },
        label: {
            color: "#b7b7b7",
        },
        input: {
            color: "#fff",
            borderColor: "#575656",
        },
        placeholder: {
            color: "#6a6a6a",
        }
    } : {};
    return (
        <Box
            w="100%"
            h="56px"
            borderRadius={themeStyle?.box?.borderRadius || "8px"}
            border={themeStyle?.box?.border || "1px solid #b0b0b0"}
            p="12px 5px 9px 12px"
        >
            <Text
                h="15px"
                lineHeight="15px"
                fontSize="12px"
                color={themeStyle?.label?.color || "#6a6a6a"}
            >{label}</Text>
            <Input
                placeholder={placeholder}
                value={value}
                borderRadius={0}
                borderColor="transparent"
                h="20px"
                w="100%"
                fontSize="16px"
                color={themeStyle?.input?.color || "#222"}
                p="0"
                m="0"
                outline="none"
                boxShadow="none"
                border="none"
                onBlur={onBlur}
                _focus={{
                    border: "none",
                    boxShadow: "none",
                    outline: "none"
                }}
                sx={{
                    "&::placeholder": {
                        color: themeStyle?.placeholder?.color || "#999",
                    }
                }}
                
                disabled={disabled}
                onChange={(e) => onChange(e.target.value)}
            />
        </Box>  
    );
}

export default InputComponent;